import type { AnyFunction, TargetStore } from "./private.types";
import type { InvocationOptions, ExtendedPromise } from "./public.types";

export function invokeSignalListenersDefault(
  thisArg: unknown,
  store: TargetStore,
  argArray: unknown[],
): Promise<unknown> {
  return new Promise((resolve) => {
    /*                             */
    const results = [...store.listeners].map((l) => {
      /*                                          */
      /*                                     */
      /*                                                                          */
      try {
        return l.apply(thisArg, argArray);
      } catch (e) {
        return e;
      }
    });

    resolve(results);
  });
}

/**
 *
 *
 *
 *
 *
 */
export function withOptions(
  promise: Promise<unknown>,
  store: TargetStore,
  { signal, timeout }: InvocationOptions,
): Promise<unknown> {
  const races: Promise<unknown>[] = [promise];

  if (timeout) {
    races.push(
      new Promise((_, reject) => {
        setTimeout(() => {
          reject(Error(`Could not provide ${store.path} within defined timeout: ${timeout}`));
        }, timeout);
      }),
    );
  }

  if (signal) {
    races.push(
      new Promise((_, reject) => {
        signal.addEventListener("abort", () => {
          reject(
            Error(`Processing of ${store.path} cancelled due to abort signal: ${signal.reason}`),
          );
        });
      }),
    );
  }

  return Promise.race(races);
}

/**
 *
 *
 *
 *
 *
 *
 */
export function invokeQueueHandlerAsync(
  thisArg: unknown,
  store: TargetStore,
  argArray: unknown[],
): unknown | Promise<unknown> {
  /*                                        */
  const res = new Promise((resolve, reject) => {
    /*                          */
    if (!store.handler) {
      store.invocations.push([thisArg, argArray, resolve, reject]);
      return;
    }

    /*                               */
    /*                                               */
    /*                      */
    /*                                                 */
    /*                                  */
    try {
      resolve(store.handler.apply(thisArg, argArray));
    } catch (e) {
      reject(e);
    }
  }) as ExtendedPromise<unknown>;

  /*                                               */
  res.with = (options) => withOptions(res, store, options);

  return res;
}

/**
 *
 *
 *
 *
 *
 *
 *
 */
export function invokeQueueHandlerSync(
  thisArg: unknown,
  store: TargetStore,
  argArray: unknown[],
): unknown | Promise<unknown> {
  const handler = store.handler as AnyFunction;
  if (import.meta.env.MODE === "test") {
    return handler?.apply(thisArg, argArray);
  }
  return handler.apply(thisArg, argArray);
}
